import React from "react";
import { DateTimeStandard, Card, Box } from "@curves/ui-base";
import { Grid } from "@mui/material";
import { parseDate } from "@util/moment";
import { formatCurrencyFn, formatMobileNumber } from "@util/utils";

/**
 * 循環訂單主單摘要卡片（用於變更單頁面）
 * 顯示會員基本資訊 + 主單重要資訊
 */
const CyclePurchaseSummaryCard = ({ sourceData: orderData = {} }) => {
	// 定義顯示的資訊欄位（會員資訊 + 主單摘要）
	const summaryInfo = [
		// 會員資訊
		{
			key: "memberName",
			text: "會員姓名",
		},
		{
			key: "memberNo",
			text: "會員編號",
		},
		{
			key: "cellPhone",
			text: "電話/手機",
			formatter: value => (value ? formatMobileNumber(value) : ""),
		},
		// 主單資訊
		{
			key: "cycleOrderTypeText",
			text: "訂單狀態",
		},
		{
			key: "cycleOrderNo",
			text: "主單編號",
		},
		{
			key: "saleAmount",
			text: "訂單金額",
			formatter: value => formatCurrencyFn(value, { symbol: "$" }),
		},
		{
			key: "shippingDayText",
			text: "出貨週期",
			formatter: value => {
				if (value) return `${value}日`;
				return "";
			},
		},

		{
			key: "firstShipmentMonth",
			text: "首次出貨月",
			formatter: value => parseDate(value, "YYYY年MM月"),
		},
		{
			key: "cycleOrderDate",
			text: "建單日期",
			formatter: value => parseDate(value, DateTimeStandard.DisplayDateBySlash),
		},
	];

	const handleValue = (value, formatter) => {
		if (!formatter) return value || "-";
		if (typeof formatter === "function") return formatter(value);
		return value || "-";
	};

	return (
		<Card className="order-info-card mb-4">
			<Card.CardHeader title="主單摘要" className="bg-light-active px-4" />
			<Card.CardContent className="px-4 pt-3 pb-2">
				<Grid spacing={2} container>
					{summaryInfo.map((item, i) => {
						const { key, text, formatter } = item;
						return (
							<Grid key={`${key}-${i}`} className="mb-1" xs={6} lg={4} xl={3} item>
								<Grid spacing={2} container>
									<Grid xs={5} item>
										<Box className="font-color-3">{text}</Box>
									</Grid>
									<Grid xs={7} item>
										<Box>{handleValue(orderData[key], formatter)}</Box>
									</Grid>
								</Grid>
							</Grid>
						);
					})}
				</Grid>
			</Card.CardContent>
		</Card>
	);
};

export default CyclePurchaseSummaryCard;
